module.exports = __webpack_public_path__ + "img/20240920072332050c9n.5747f3ed.jpg";